var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"200px","text-align":"center","font-size":"28px"}},[(_vm.res)?_c('div',[_vm._v(_vm._s(_vm.res))]):_c('div',[_vm._v("处理中...")])])}
var staticRenderFns = []

export { render, staticRenderFns }